import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './queries';
import { LoginRequest, LoginResponse, SignupRequest, OTPRequest, OTPVerifyRequest } from 'types';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: axiosBaseQuery({
    baseUrl: import.meta.env.VITE_APP_BASE_URL as string,
  }),
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (data) => ({ 
        url: '/v1/auth/login/', 
        method: 'post', 
        data 
      }),
    }),
    signup: builder.mutation<LoginResponse, SignupRequest>({
      query: (data) => ({ 
        url: '/v1/auth/signup/', 
        method: 'post', 
        data 
      }),
    }),
    sendOTP: builder.mutation<{ success: boolean; message: string }, OTPRequest>({
      query: (data) => ({ 
        url: '/v1/auth/send-otp/', 
        method: 'post', 
        data 
      }),
    }),
    verifyOTP: builder.mutation<LoginResponse, OTPVerifyRequest>({
      query: (data) => ({ 
        url: '/v1/auth/verify-otp/', 
        method: 'post', 
        data 
      }),
    }),
    sendSignupOTP: builder.mutation<{ success: boolean; message: string }, OTPRequest>({
      query: (data) => ({ 
        url: '/v1/auth/send-signup-otp/', 
        method: 'post', 
        data 
      }),
    }),
    verifySignupOTP: builder.mutation<LoginResponse, { email: string; otp: string; workspaceName: string; userName: string }>({
      query: (data) => ({ 
        url: '/v1/auth/verify-signup-otp/', 
        method: 'post', 
        data 
      }),
    }),
    logout: builder.mutation<void, void>({
      query: () => ({ 
        url: '/v1/auth/logout/', 
        method: 'post' 
      }),
    }),
    refreshToken: builder.mutation<{ access_token: string }, { refresh_token: string }>({
      query: (data) => ({ 
        url: '/v1/auth/refresh/', 
        method: 'post', 
        data 
      }),
    }),
    switchWorkspace: builder.mutation<{ success: boolean; message: string; workspace_id: string }, { workspace_id: string }>({
      query: (data) => ({ 
        url: '/v1/auth/switch-workspace/', 
        method: 'post', 
        data 
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useSignupMutation,
  useSendOTPMutation,
  useVerifyOTPMutation,
  useSendSignupOTPMutation,
  useVerifySignupOTPMutation,
  useLogoutMutation,
  useRefreshTokenMutation,
  useSwitchWorkspaceMutation,
} = authApi;

